export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const DECREASE_PRICE = "DECREASE_PRICE";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";
export const PRE_REMOVE_ITEM = "PRE_REMOVE_ITEM";
export const UPDATE_ALL_PRICES = "UPDATE_ALL_PRICES";

//add to cart
export const addToCart = (
  item,
  sizeType,
  addToast,
  quantityCount,
  // vendor,
  description,
  selectedProductColor,
  primaryImage,
  totalPrice,
  decorations,
  decorationType,
  totalFee,
  personalization,
  slugid,
  taxCode,
  productName,
  totalQuantity,
  decoId,
  discountedFee,
  discountedPrice,
  discountId,
  formula,
  taxExempt,
  shipExempt
) => {
  return dispatch => {
//    if (addToast) {
//      addToast("Added To Cart", { appearance: "success", autoDismiss: true });
//    }
    dispatch({
      type: ADD_TO_CART,
      payload: {
        productId: item,
        sizeType: sizeType || 'Adult',
        decorationType: decorationType,
        decorations: decorations,
        totalPrice: totalPrice,
        sizes: quantityCount,
        color: selectedProductColor
          ? selectedProductColor
          : item.selectedProductColor
          ? item.selectedProductColor
          : null,
        selectedProductSize: null,
          description: description,
          primaryImage: primaryImage,
          totalFee: totalFee,
        personalization: personalization,
        // vendor: vendor,
        slugid: slugid,
        taxCode: taxCode,
        productName: productName,
        totalQuantity: totalQuantity,
        decoId: decoId,
        discountedFee: discountedFee,
        discountedPrice: discountedPrice,
        discountId: discountId,
        formula: formula,
        taxExempt: taxExempt,
        shippingExempt: shipExempt
      }
    });
  };
};
//decrease from cart
export const decreaseQuantity = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Item Decremented From Cart", {
        appearance: "warning",
        autoDismiss: true
      });
    }
    dispatch({ type: DECREASE_QUANTITY, payload: item });
  };
};

export const decreasePrice = (newPrice, addToast) => {
  return dispatch => {
    dispatch({ type: DECREASE_PRICE, payload: {newPrice} });
  };
};
export const updatePrices = (item, addToast) => {
  return dispatch => {
    dispatch({ type: PRE_REMOVE_ITEM, payload: item });
  };
};

export const updateAllPrices = (item, addToast) => {
  return dispatch => {
    dispatch({ type: UPDATE_ALL_PRICES, payload: item });
  };
};
//delete from cart
export const deleteFromCart = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_FROM_CART, payload: item });
  };
};
//delete all from cart
export const deleteAllFromCart = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Removed All From Cart", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: DELETE_ALL_FROM_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single.color === color)[0]
      .size.filter(single => single.name === size)[0].stock;
  }
};